import {
    createContext,
    Dispatch,
    ReactNode,
    SetStateAction,
    useEffect,
    useMemo,
    useState,
} from 'react'

interface Props {
    children: ReactNode
}

export const PageContext = createContext({
    showSidebar: false,
    setShowSidebar: () => {},
    smallScreen: false,
} as {
    showSidebar: boolean
    setShowSidebar: Dispatch<SetStateAction<boolean>>
    smallScreen: boolean
})

const PageProvider = ({ children }: Props) => {
    const [showSidebar, setShowSidebar] = useState<boolean>(false)
    const [windowWidth, setWindowWidth] = useState(window.innerWidth)

    const isSmallScreen = () => {
        if (window.innerWidth < 768) {
            return true
        } else {
            return false
        }
    }

    const [smallScreen, setSmallScreen] = useState<boolean>(isSmallScreen())

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth)
            if (isSmallScreen()) {
                setSmallScreen(true)
            } else {
                setSmallScreen(false)
            }
        }

        window.addEventListener('resize', handleResize)

        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [windowWidth])

    const providerValues = useMemo(
        () => ({
            showSidebar,
            setShowSidebar,
            smallScreen,
        }),
        [showSidebar, setShowSidebar, smallScreen],
    )

    return <PageContext.Provider value={providerValues}>{children}</PageContext.Provider>
}

export default PageProvider
